import clsx from 'clsx'
import {
  AllReactions,
  Author,
  Avatar,
  PostInfo,
  PostInfoWrapper,
  PostText,
  Reaction,
  ReactionsWrapper
} from './postCardSkeleton.styles'
import { PostCardSkeletonProps } from './postCardSkeleton.types'

const PostCardSkeleton = ({ length = 1, className }: PostCardSkeletonProps) => {
  return (
    <>
      {Array.from({ length }, (_, index) => (
        <div
          key={index}
          className={clsx('_border-bottom _border-gray-200 _px-4 _py-5', className)}
          role="status"
          aria-busy="true"
          data-test="post-card-skeleton"
        >
          <header className="_d-flex _align-items-center _pb-4">
            <Avatar className="_rounded-circle _mr-3" />
            <Author className="_rounded-pill" />
          </header>

          <div className="_pb-4">
            <PostText className="_rounded-pill _mb-4" />
            <PostText className="_rounded-pill _mb-2" />
            <PostText className="_rounded-pill _mb-2" />
            <PostText className="_rounded-pill" />
          </div>

          <ReactionsWrapper className="_d-flex _align-items-center _border-bottom _border-gray-200 _pb-4">
            <AllReactions className="_rounded-circle" />
            <Reaction className="_rounded-pill" />
            <Reaction className="_rounded-pill" />
            <Reaction className="_rounded-pill" />
          </ReactionsWrapper>

          <PostInfoWrapper className="_d-flex _align-items-center _pt-4">
            <PostInfo className="_rounded-pill" />
            <PostInfo className="_rounded-pill" />
          </PostInfoWrapper>
        </div>
      ))}
    </>
  )
}

export default PostCardSkeleton
